export default __webpack_public_path__ + "static/media/downArrow.76b42abb.png";